import { keepPreviousData, skipToken } from "@tanstack/query-core";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const brandsQueryOptions = (searchTerm: string, selectedBrandIds: string[] = []) =>
  queryOptions({
    queryKey: ["brands", { searchTerm, selectedBrandIds }],
    placeholderData: keepPreviousData,
    queryFn:
      !searchTerm && selectedBrandIds.length === 0
        ? skipToken
        : () => rpc("brandsSearch", { searchTerm, selectedBrandIds }),
  });
